import __store from '@/store/index.ts'

function dispatchStatus () {
  __store.dispatch('setAppOnlineStatus', navigator.onLine)
}

function initServiceWorker () {
  window.addEventListener('online', dispatchStatus)
  window.addEventListener('offline', dispatchStatus)
  dispatchStatus()
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(`${process.env.VUE_APP_PUBLIC_PATH}service-worker.js`)
    })
  }
}

initServiceWorker()
